//
// ████████╗██╗  ██╗███████╗███╗   ███╗███████╗
// ╚══██╔══╝██║  ██║██╔════╝████╗ ████║██╔════╝
//    ██║   ███████║█████╗  ██╔████╔██║█████╗
//    ██║   ██╔══██║██╔══╝  ██║╚██╔╝██║██╔══╝
//    ██║   ██║  ██║███████╗██║ ╚═╝ ██║███████╗
//    ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚══════╝
//
export const containers = {
  sm: '395px',
  md: '738px',
  lg: '994px',
  xl: '1170px',
  fluid: '100%'
};
export const breakpoints = ['425px', '768px', '1024px', '1200px', '1920px']; // used by '@rebass/grid'

export const space = [0, 6, 12, 18, 24, 30, 36, 42, 48, 54, 60]; // used by '@rebass/grid'

export const spacer = '6px';
export const urlBarHeight = () => {
  // TODO: Check this and repair if necessary, EBH is using <html> tag and it works, but it ruins position: fixed for the website
  const rootDiv = typeof document !== 'undefined' ? document.getElementById('root') : undefined;

  if (rootDiv) {
    const totalHeight = parseFloat(getComputedStyle(rootDiv).perspective);
    const clientHeight = rootDiv.clientHeight;
    const urlBarHeight = totalHeight - clientHeight;
    return isNaN(urlBarHeight) ? 0 : urlBarHeight;
  }

  return 0;
};
export const colors = {
  green: '#0FCDBA',
  // NOTE: PRIMARY
  greenLighter: '#9FEBE3',
  greenLight: '#57DCCF',
  greenDark: '#0B9082',
  greenDarker: '#06524A',
  // Deprecated, replaced by yellow
  gold: '#FEDF73',
  goldLighter: '#FFF2C7',
  goldLight: '#FEE99D',
  goldDark: '#E1BA36',
  goldDarker: '#A37F0A',
  yellow: '#FEDF73',
  // NOTE: SECONDARY COLOR
  yellowLighter: '#FFF2C7',
  yellowLight: '#FEE99D',
  yellowDark: '#E1BA36',
  yellowDarker: '#A37F0A',
  purple: '#786FA6',
  purpleLight: '#A19AC1',
  purpleLighter: '#C9C5DB',
  purpleDark: '#544E74',
  purpleDarker: '#413C51',
  // NOTE: SECONDARY COLOR
  orange: '#FFAC30',
  orangeLight: '#FFC56E',
  orangeLighter: '#FFDEAC',
  orangeDark: '#E18600',
  orangeDarker: '#8D5806',
  red: '#FC656B',
  redLight: '#FD9397',
  redLighter: '#FEC1C4',
  redDark: '#C52329',
  redDarker: '#991A20',
  blue: '#45AAF2',
  blueLight: '#7DC4F6',
  blueLighter: '#B5DDFA',
  blueDark: '#1A7CC1',
  blueDarker: '#0C4D7B',
  darkBlue: '#33658A',
  floral: '#FEF8ED',
  mint: '#E7FAF8',
  lavender: '#F3F2FB',
  gray: '#CCC',
  grayLighter: '#FAFAFA',
  grayLight: '#EEE',
  grayDark: '#999',
  grayDarker: '#666',
  grayBlack: '#333',
  greenSlate: '#E7FAF8',
  // Mint
  goldSlate: '#FEF8ED',
  // Floral
  transparent: 'rgba(0,0,0,0)',
  labels: {
    'a++': '#008C48',
    'a+': '#008C48',
    a: '#008C48',
    b: '#00A650',
    c: '#71C043',
    d: '#FD0',
    e: '#FCB913',
    f: '#F47121',
    g: '#ED1B24'
  },
  social: {
    facebook: '#3B5998',
    linkedIn: '#007BB6',
    twitter: '#00ACED',
    pinterest: '#CB2027',
    youtube: '#B00',
    vimeo: '#AAD450',
    tumblr: '#32506D',
    instagram: '#517FA4',
    whatsApp: '#25D366'
  },
  abn: {
    primary: '#019186',
    secondary: '#F0BF19'
  },
  florius: {
    primary: '#C2E20E',
    secondary: '#1F3D8F'
  },
  munt: {
    primary: '#00DDA5',
    secondary: '#E5FBF6'
  },
  triodos: {
    primary: '#4BF0B9',
    secondary: '#00006B'
  },
  financieelFit: {
    primary: '#2D728B',
    secondary: '#5CC2CB'
  },
  gaVoorA: {
    primary: '#289941',
    secondary: '#B2CC15'
  },
  veldsink: {
    primary: '#519E19',
    secondary: '#EC8636'
  }
};
export const type = {
  fontSizeRoot: '16px',
  fontSizeBase: '1rem',
  lineHeightBase: '1.5',
  letterSpacingBase: '0',
  letterSpacingHeadings: '-0.025em',
  fontFamilyHeadings: 'Causten, Causten Round, Helvetica, Arial, sans-serif',
  fontFamilyBody: 'Causten Round, Helvetica, Arial, sans-serif',
  fontFamilySans: 'Causten Round, Helvetica, Arial, sans-serif',
  fontFamilySerif: 'Lora, Georgia, "Times New Roman", serif',
  scale: ['5rem', '3rem', '2.25rem', '1.5rem', '1.25rem', '1rem', '0.875rem', '0.75rem', '0.65rem', '0.5rem']
};
export const curves = {
  standard: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
  // natural easing in and out
  decelerate: 'cubic-bezier(0.4, 0.0, 1, 1)',
  // for elements entering the screen and slowing to a halt
  accelerate: 'cubic-bezier(0.0, 0.0, 0.2, 1)',
  // for elements leaving the screen at full speed
  sharp: 'cubic-bezier(0.4, 0.0, 0.6, 1)',
  // for elements leaving the screen that may return at any time
  bouncy: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)'
};
export const z = {
  super: 9999,
  tooltip: 1800,
  popover: 1700,
  toast: 1650,
  toaster: 1600,
  modal: 1500,
  modalMask: 1400,
  maskedNav: 1300,
  maskedSubnav: 1200,
  navMask: 1100,
  nav: 1000,
  subnav: 900,
  sticky: 800,
  banner: 700,
  base: 100,
  sub: -1,
  deepDive: -9999
};
const theme = {
  breakpoints,
  containers,
  space,
  spacer,
  type,
  colors,
  curves,
  urlBarHeight,
  z
};
export default theme;